export enum EquipmentsEventType {
    EquipmentsUpdated = "equipments_updated"
}
